(() => {
  function getLatitudeLongitude(address, map, marker) {
    const geocoder = new google.maps.Geocoder();
    if (geocoder) {
      geocoder.geocode({
        address
      }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const lat = results[0].geometry.location.lat();
          const lng = results[0].geometry.location.lng();

          const myLatLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          };

          showResults(myLatLng, map, marker);
        }
      });
    }
  }

  function showResults(myLatLng, map, marker) {
    map.setCenter(myLatLng);
    marker.setPosition(myLatLng);
  }

  const maxSeconds = 60;
  let timer = 1;

  const refreshId = setInterval(() => {
    if (document.querySelector('.m32__container')) {
      const mapEl = document.querySelector('.gmap');
      clearInterval(refreshId);
      observer(mapEl);
    }

    if (timer++ >= maxSeconds) {
      clearInterval(refreshId);
    }
  }, 1000);

  function observer(mapEl) {
    if (mapEl === null) {
      return;
    }
    // const mapEl = document.querySelector('.gmap');
    const mapAddress = mapEl.getAttribute('data-address');

    const googleMap = new google.maps.Map(mapEl, {
      zoom: 13,
      center: { lng: 0, lat: 0 },
      rotateControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false
    });

    const googleMarker = new google.maps.Marker({
      map: googleMap,
      position: { lat: 0, lng: 0 }
    });

    getLatitudeLongitude(mapAddress, googleMap, googleMarker);

    const officeSelect = document.querySelector('.m32__select');
    if (officeSelect === null) {
      return;
    }

    officeSelect.addEventListener('change', e => {
      const value = e.target.value;

      jQuery.ajax({
        url: luna.admin_url,
        type: 'post',
        dataType: 'html',
        data: {
          action: 'get_new_address',
          post_id: value
        },
        beforeSend: () => {
          document.body.classList.add('is-loading');
        },
        success: data => {
          const addressEl = document.querySelector('.m32__address');
          if (addressEl !== null) {
            addressEl.innerHTML = data;
          }

          const linkWrap = addressEl.querySelector('.m32__address-wrap');

          if (linkWrap !== null) {
            const address = linkWrap.getAttribute('data-address');
            const linkURL = linkWrap.getAttribute('data-link');
            const button = document.querySelector('.m32__button');

            getLatitudeLongitude(address, googleMap, googleMarker);

            if (button !== null) {
              button.href = linkURL;
            }
          }
        },
        complete: () => {
          setTimeout(() => {
            document.body.classList.remove('is-loading');
          }, 250);
        }
      });
    });
  }
})();
